'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024 from "./dev.cheleb.scalamigen.-Form$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_SimpleSample$package$$anon$3() {
}
export { $c_Lsamples_SimpleSample$package$$anon$3 as $c_Lsamples_SimpleSample$package$$anon$3 };
$p = $c_Lsamples_SimpleSample$package$$anon$3.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_SimpleSample$package$$anon$3;
/** @constructor */
function $h_Lsamples_SimpleSample$package$$anon$3() {
}
export { $h_Lsamples_SimpleSample$package$$anon$3 as $h_Lsamples_SimpleSample$package$$anon$3 };
$h_Lsamples_SimpleSample$package$$anon$3.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.h = (function() {
  return $j_dev$002echeleb$002escalamigen$002e$002dForm$0024.$m_Ldev_cheleb_scalamigen_Form$().eU();
});
var $d_Lsamples_SimpleSample$package$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_SimpleSample$package$$anon$3, "samples.SimpleSample$package$$anon$3", ({
  qU: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_SimpleSample$package$$anon$3 as $d_Lsamples_SimpleSample$package$$anon$3 };
